import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { IPrescriptionsMedication, MEDICINE_STATUSES } from 'API';
import { ListDivider } from 'Components';
import { AccordionExpandIconBlue } from 'Components/AccordionExpandIconBlue';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useState } from 'react';
import { MedicineItem } from './MedicineItem';

interface IEquipmentListProps {
  orderItems: IPrescriptionsMedication[];
  currentStatus: number;
  eligibleNotes?: string;
}

export const MedicineList = ({
  orderItems,
  currentStatus,
  eligibleNotes,
}: IEquipmentListProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const isSuppliedOrPartial =
    !!orderItems.find((item) => item.supplyind) &&
    (currentStatus === MEDICINE_STATUSES.SUPERPHARM_FULL_SUPPLY ||
      currentStatus === MEDICINE_STATUSES.SUPERPHARM_PARTIAL_SUPPLY);

  return isDesktop ? (
    <>
      <Typography component={'h3'} variant='h5'>
        {dictionary.prescriptionMedicationsAmount(orderItems.length)}
      </Typography>
      <Grid
        container
        direction={'column'}
        mt={3}
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          p: 3,
        }}
      >
        <Grid container item mb={2}>
          <Grid item xs={6} md={isSuppliedOrPartial ? 3 : 4}>
            <Typography>{dictionary.nameOfTheMedication}</Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography>{dictionary.dosageText}</Typography>
          </Grid>
          <Grid item xs={6} md={isSuppliedOrPartial ? 3 : 4}>
            <Typography>{dictionary.notes}</Typography>
          </Grid>
          {isSuppliedOrPartial && (
            <Grid item xs={6} md={2}>
              <Typography>{dictionary.status}</Typography>
            </Grid>
          )}
        </Grid>
        <ListDivider />
        {orderItems.map((item) => (
          <MedicineItem
            key={item.medicatioN_CODE}
            item={item}
            isSuppliedOrPartial={isSuppliedOrPartial}
          />
        ))}
        {eligibleNotes && (
          <>
            <Typography variant='body4' mt={4}>
              {dictionary.orderComments}
            </Typography>

            <Typography variant='body6' mt={'5px'} mb={1}>
              {eligibleNotes}
            </Typography>
          </>
        )}
      </Grid>
    </>
  ) : (
    <Accordion
      sx={{
        width: '100%',
        boxShadow: 'none',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '16px !important',
        '&:before': {
          display: 'none',
        },
        mb: '24px !important',
      }}
    >
      <AccordionSummary
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
        expandIcon={<AccordionExpandIconBlue />}
        sx={{ p: '8px 16px' }}
      >
        <Typography>
          {dictionary.prescriptionMedicationsAmount(orderItems.length)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: '0 16px 16px 16px' }}>
        <Divider
          aria-hidden={true}
          sx={{ borderColor: 'primary.shade_100', mb: 3 }}
        />

        {orderItems.map((item) => (
          <MedicineItem
            key={item.medicatioN_CODE}
            item={item}
            isSuppliedOrPartial={isSuppliedOrPartial}
          />
        ))}
        {eligibleNotes && (
          <Stack>
            <Typography variant='body1' mt={4}>
              {dictionary.orderComments}
            </Typography>

            <Typography variant='body3' mt={'5px'} mb={1}>
              {eligibleNotes}
            </Typography>
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
